import Certificates from '@/components/landing/footer/menu/Certificates'
import IconCallOutlineIcon from '@/components/common/icons/IconCallOutline'
import IconEmailIcon from '@/components/common/icons/IconEmail'
import IconLocationIcon from '@/components/common/icons/IconLocation'
import { legalLinks, quickAccessLinks } from '@/data/landing/footerLinks'
import { type FC } from 'react'

const footerLinkClass =
  'block text-sm text-slate-600 transition-colors hover:text-[#FF0000]'

const Footer: FC = () => {
  return (
    <footer className="bg-[#F7F8FA]">
      <div className="mx-auto grid w-full max-w-[1280px] gap-10 px-4 py-12 tablet:grid-cols-2 tablet:px-6 desktop:grid-cols-4 desktop:px-8 desktop:py-14">
        <div>
          <a href="/" className="inline-flex items-center" aria-label="آپولون">
            <img
              src="/assets/images/Svg/logo.png"
              alt="آپولون"
              className="h-[56px] w-[48px] object-contain"
            />
          </a>
          <p className="mt-4 text-sm font-semibold leading-7 text-slate-800">
            بازوی اعتباری بانک شهر با همکاری هلدینگ آسان پرداخت و شرکت دیجی‌شهر
          </p>
          <p className="mt-3 text-sm leading-7 text-slate-600">
            امکان دریافت اعتبار و خرید اعتباری از فروشگاه‌های آنلاین و حضوری طرف
            قرارداد.
          </p>
        </div>

        <div>
          <h3 className="mb-4 text-sm font-bold text-slate-900">دسترسی سریع</h3>
          <nav className="flex flex-col gap-2.5">
            {quickAccessLinks.map((link) => (
              <a key={link.label} href={link.link} className={footerLinkClass}>
                {link.label}
              </a>
            ))}
          </nav>
        </div>

        <div>
          <h3 className="mb-4 text-sm font-bold text-slate-900">پشتیبانی و ارتباط با ما</h3>
          <ul className="flex flex-col gap-4 text-sm text-slate-600">
            <li className="flex items-start gap-2.5">
              <IconCallOutlineIcon className="mt-0.5 size-[18px] shrink-0 text-[#FF0000]" />
              <div>
                <div className="text-xs text-slate-500">شماره تماس پذیرندگان</div>
                <a
                  href="tel:+982128424273"
                  className="ss02 mt-0.5 inline-block font-medium text-slate-700 transition-colors hover:text-[#FF0000]"
                >
                  ۰۲۱-۲۸۴۲۴۲۷۳
                </a>
              </div>
            </li>
            <li className="flex items-start gap-2.5">
              <IconEmailIcon className="mt-0.5 size-[18px] shrink-0 text-[#FF0000]" />
              <a
                href="mailto:salam@myapoloan.com"
                className="break-all transition-colors hover:text-[#FF0000]"
                dir="ltr"
              >
                salam@myapoloan.com
              </a>
            </li>
            <li className="flex items-start gap-2.5">
              <IconLocationIcon className="mt-0.5 size-[18px] shrink-0 text-[#FF0000]" />
              <span className="leading-7">
                تهران، خیابان حبیب‌اله، پلاک ۵۶، ساختمان ایستگاه نوآوری شریف
              </span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="mb-4 text-sm font-bold text-slate-900">اطلاعات حقوقی</h3>
          <p className="text-sm font-semibold leading-7 text-slate-800">
            شرکت سهامی خاص نوآوران کسب‌وکار آسان
          </p>
          <p className="ss02 mt-3 text-xs leading-6 text-slate-500">
            شناسه ملی: ۱۴۰۱۵۳۰۹۶۷۰
          </p>
          <p className="ss02 text-xs leading-6 text-slate-500">شماره ثبت: ۶۷۲۱۵۲</p>
        </div>
      </div>

      <div className="border-t border-slate-200">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-6 px-4 py-6 tablet:px-6 desktop:px-8">
          <div className="flex flex-col gap-6 desktop:flex-row desktop:items-center desktop:justify-between">
            <nav className="flex flex-wrap gap-x-5 gap-y-2">
              {legalLinks.map((link) => (
                <a key={link.label} href={link.link} className={footerLinkClass}>
                  {link.label}
                </a>
              ))}
            </nav>

            <div className="flex flex-wrap items-center gap-4">
              <Certificates />
            </div>
          </div>

          <p className="text-xs leading-6 text-slate-500">
            تمامی حقوق مادی و معنوی این وب‌سایت متعلق به شرکت سهامی خاص نوآوران
            کسب‌وکار آسان است.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
